import { Button, Table, TableBody, TableCell, TableHead, TableRow, Theme, WithStyles, createStyles, withStyles } from "@material-ui/core";
import { IStoreState, ThunkDispatch } from "../../../modules";
import PhoneNumberInput, { PhoneNumberEnrolment, newEnrolment } from "../../../components/PhoneNumberInput";
import React, { Fragment } from "react";
import { deleteOobPhone, getEnrolledCredentials, updateOobPhone } from "../../../modules/authmethods";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GenericEnroll from "./GenericEnroll";
import PropTypes from 'prop-types';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { enrolmentToContactList } from "../../../helpers/credentials/OobPhone";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const styles = (theme: Theme) => createStyles({
  phoneEnrolments: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  phoneEnrolment: {
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  phoneInput: {
    flex: 1,
  },
  buttonToolbar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: theme.spacing(2)
  },
  addIcon: {
    marginRight: theme.spacing(1)
  },
})

type OobPhoneEnrollState = {
  enrolments: PhoneNumberEnrolment[]
  loading: { [key: number]: boolean }
  error: string
}

class OobPhoneEnroll extends React.Component<Props, OobPhoneEnrollState> {
  static propTypes = {
    expanded: PropTypes.bool.isRequired,
    setExpanded: PropTypes.func.isRequired
  }

  state = {
    enrolments: [] as PhoneNumberEnrolment[],
    loading: {},
    error: "",
  }

  componentDidMount = () => {
    this.loadStateFromProps()
  }

  loadStateFromProps = () => {
    let enrolments = this.props.authmethods.oobPhone.enrolments

    this.setState({
      enrolments,
      loading: {},
      error: "",
    })
  }

  handleCancel = () => { }

  handleSaveButton = () => {
    let contactList = this.state.enrolments.map(pne => ({
      defaultFlag: pne.default,
      label: pne.key,
      phoneNumber: pne.phoneNumber.getNumber().replace(/\D/, "")
    }))

    this.props.updateOobPhone(contactList).then((data: any) => {
      this.props.setExpanded(false)
      return data
    }).catch((error: Error) => {
      console.error(error)
      this.setState({ error: "Error setting OobPhone" })
    })
  }

  handleAdd = () => {
    this.setState({
      enrolments: this.state.enrolments.concat(newEnrolment())
    })
  }

  handleDelete = (pne: PhoneNumberEnrolment) => (fromDatabase: boolean) => {
    if (fromDatabase) {
      return this.props.deleteOobPhone(enrolmentToContactList(pne)).then(() => {
        return this.props.getEnrolledCredentials().then(() => {
          this.loadStateFromProps()
        })
      })
    }
    else {
      this.setState(prevState => ({
        enrolments: prevState.enrolments.filter(e => pne !== e)
      }))
      return (Promise.resolve()) as Promise<any>
    }
  }

  handlePhoneNumberInputChange = (i: number) => (pne: PhoneNumberEnrolment): Promise<boolean> => {
    return new Promise((resolve) => {
      this.setState(prevState => {
        const enrolments = prevState.enrolments.map((item, j) => {
          if (i === j) {
            return pne
          } else {
            return {
              ...item,
              default: pne.default ? false : item.default
            }
          }
        })
        return { enrolments }
      }, () => resolve(true))
    })
  }

  // should not have a then clause to this return, only catch

  handleSave = (pne: PhoneNumberEnrolment): Promise<boolean> =>
    this.props.updateOobPhone(enrolmentToContactList(pne))
      .then((_: any) => {
        return this.props.getEnrolledCredentials().then((data: any) => {
          this.loadStateFromProps()
          return true
        })
      })
      .catch((error: Error) => {
        console.error(error)
        throw error
      })

  renderForm = () => {
    const { classes } = this.props
    const { enrolments: phoneNumbers } = this.state

    return <Fragment>
      <div className={classes.phoneEnrolments}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Default</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>{/* delete */}</TableCell>
              <TableCell>{/* status */}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {phoneNumbers.length > 0 ?
              phoneNumbers.sort((a, b) => (a.key > b.key) ? 1 : ((b.key > a.key) ? -1 : 0)).map((pne, i) =>
                <PhoneNumberInput
                  key={pne.key}
                  onDelete={this.handleDelete(pne)}
                  className={classes.phoneEnrolment}
                  enrolment={pne}
                  onChange={this.handlePhoneNumberInputChange(i)}
                  onSave={this.handleSave} />
              )
              : <TableRow>
                <TableCell colSpan={4} align="center">No phone numbers enrolled</TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </div>
      <div className={classes.buttonToolbar}>
        <Button onClick={this.handleAdd} color="primary"><FontAwesomeIcon icon={faPlus} className={classes.addIcon} /> Add a phone</Button>
      </div>
    </Fragment>
  }

  render = () => {
    return <GenericEnroll
      authMethodName="Out-of-Band Phone"
      enrolled={this.props.authmethods.oobPhone.enrolled}
      renderForm={this.renderForm}
      expanded={this.props.expanded}
      setExpanded={this.props.setExpanded}
      error=""
      saveDisabled={!this.state.enrolments.map(pne => pne.phoneNumber.isValid()).every(a => a)}
      dirty={false} />
  }
}

const mapStateToProps = ({ accounts, authmethods, intl }: IStoreState) => ({
  accounts,
  authmethods,
  intl
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      getEnrolledCredentials,
      updateOobPhone,
      deleteOobPhone
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  expandNext: () => void
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OobPhoneEnroll))